import * as React from 'react';
import { Select, Row, Col } from 'antd';
import { TimeZoneApi } from '../apis/time-zone-api';

const { Option } = Select; 

type Props = {
    timezoneId: number;
    onChange: Function;
    span: number;
    timeZoneRef?: React.MutableRefObject<undefined>,
    setTimeZoneName?: React.Dispatch<React.SetStateAction<string>>,
    isSavingDeadline?: boolean,
}

const TimeZoneSelect: React.FC<Props> = ({
    timezoneId,
    onChange,
    span,
    timeZoneRef,
    setTimeZoneName,
    isSavingDeadline = false,
}) => {
  const [timezoneList, setTimezoneList] = React.useState([]);
  const [timezoneSearchList, setTimezoneSearchList] = React.useState([]);

  const handleSearch = (value) => {
    if(value) {
      const filteredData = timezoneList.filter((time) => time.name.toLowerCase().includes(value.toLowerCase()));
      setTimezoneSearchList(filteredData);
    } else {
      setTimezoneSearchList(timezoneList);
    }
  }

  React.useEffect(() => {
    const getTimezoneList = async() => {
      const TimezoneList = await TimeZoneApi.getTimeZones();
      const sortedTimezoneList = TimezoneList.sort((a,b) => a.name.localeCompare(b.name));
      setTimezoneList(sortedTimezoneList);
      setTimezoneSearchList(sortedTimezoneList);

      if (setTimeZoneName)
        setTimeZoneName(sortedTimezoneList.find(z => z.id === timezoneId).name);
    }

    if(timezoneList.length === 0) {
      getTimezoneList();
    } 
  }, [timezoneId])

  return(
    <Row wrap={false}>
      <Col xs={span} md={span} xxl={span}>
        <Select
          value={timezoneId}
          onSelect={(val) => {
            if (setTimeZoneName)
              setTimeZoneName(timezoneSearchList.find(z => z.id === val).name);
            onChange(val);
          }}
          onSearch={handleSearch}
          filterOption={false}
          showSearch
          ref={timeZoneRef}
          disabled={isSavingDeadline}
          dropdownMatchSelectWidth={false}
        >
          {timezoneSearchList && timezoneSearchList.map((timeZ) => (
            <Option key={timeZ.id} value={timeZ.id} className={timeZ.description}>
              {timeZ.name}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
)};

export default TimeZoneSelect;